export const queryKeys = {
  me: ['me'] as const,
  admin: (tab: string, search?: string, page?: number, limit?: number) =>
    ['admin', tab, { search: search ?? '', page: page ?? 1, limit: limit ?? 10 }] as const,
  libraryCategories: ['library', 'categories'] as const,
  libraryFiles: (categoryId?: string, search?: string, page?: number, limit?: number) =>
    ['library', 'files', categoryId ?? null, { search: search ?? '', page: page ?? 1, limit: limit ?? 10 }] as const,
};
